import { render, staticRenderFns } from "./RegisterProtocol.vue?vue&type=template&id=5ae79615&scoped=true&"
import script from "./RegisterProtocol.vue?vue&type=script&lang=js&"
export * from "./RegisterProtocol.vue?vue&type=script&lang=js&"
import style0 from "./RegisterProtocol.vue?vue&type=style&index=0&id=5ae79615&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae79615",
  null
  
)

export default component.exports